import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FieldArray, SubmissionError, reduxForm } from 'redux-form';

import { notify } from '@/actions/ui';
import EditableList from '@/components/EditableList';
import MediaQuery from '@/components/MediaQuery';
import { reportProfileSaveFailure } from '@/profile/profileSaveFailure';
import { updateProfile } from '@/profile/store';
import { SCREEN_XS } from '@/theme/screens';

const SAVE_ERROR = 'An error occurred when updating your questions.';

export class QuestionsForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func,
    component: PropTypes.func,
    reset: PropTypes.func,
    profileId: PropTypes.string,
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    updateProfile: PropTypes.func,
    notify: PropTypes.func,
  };

  handleSubmit = async (values: any) => {
    // @ts-expect-error TS(2339): Property 'profileId' does not exist on type 'Reado... Remove this comment to see the full error message
    const { profileId, onSubmit, updateProfile, notify } = this.props;

    try {
      await updateProfile({
        id: profileId,
        questions: values.questions.filter((x: any) => x),
      });
    } catch (err) {
      // SubmissionError, not a raw Error: redux-form resolves with its errors, so
      // neither EditDialog nor DeprecatedSaveForm reads the failure as a success.
      throw new SubmissionError({ _error: reportProfileSaveFailure(err, notify, SAVE_ERROR) });
    }

    if (onSubmit) onSubmit(values);
  };

  handleReset = () => {
    // @ts-expect-error TS(2339): Property 'reset' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reset, onReset } = this.props;
    reset();
    if (onReset) onReset();
  };

  render() {
    const {
      // @ts-expect-error TS(2339): Property 'component' does not exist on type 'Reado... Remove this comment to see the full error message
      component: Container,
      // @ts-expect-error TS(2339): Property 'handleSubmit' does not exist on type 'Re... Remove this comment to see the full error message
      handleSubmit,
      // @ts-expect-error TS(2339): Property 'profile' does not exist on type 'Readonl... Remove this comment to see the full error message
      profile,
      ...other
    } = this.props;

    return (
      <MediaQuery maxWidth={SCREEN_XS}>
        {(isMobileVersion: any) => {
          return (
            <Container
              {...other}
              onSubmit={handleSubmit(this.handleSubmit)}
              onReset={this.handleReset}
            >
              <FieldArray
                name="questions"
                component={EditableList}
                addButtonLabel="Question"
                inputProps={{
                  placeholder:
                    !isMobileVersion &&
                    'example: "What\'s the regulatory environment like for roads and infrastructure in Mexico?"',
                  fullWidth: true,
                }}
              />
            </Container>
          );
        }}
      </MediaQuery>
    );
  }
}

function validate(/* values */) {
  return {};
}

const WrappedQuestionsForm = reduxForm({
  form: 'expertQuestions',
  validate,
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'typeof QuestionsForm' is not ass... Remove this comment to see the full error message
})(QuestionsForm);

export default connect(
  (state, ownProps) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const profile = state.profiles.fullProfiles[ownProps.profileId];
    const questions = profile.questions && profile.questions.length > 0 ? profile.questions : [''];

    return {
      profile,
      initialValues: {
        questions,
      },
    };
  },
  {
    updateProfile,
    notify,
  }
)(WrappedQuestionsForm);
